import styled from "styled-components";
import Footer from "./Footer";
import Header from "./Header";
import Team from "./Team";

const TeamComponent =() =>{
    return(
        <>
            <Header/>
            <Banner>
                <div className="banner__container">
                    <div className="banner__content">
                        <h2>Our Team</h2>
                        <p>Working with passionate minds is what birth success in an organization.</p>
                    </div>
                    <div className="banner__background"></div>
                </div>
            </Banner>
            <Team/>
                {/* <Container>
                    <Gallery>
                        <div className="gallery__team">
                            <img src ="/images/team/team1.jpg" alt =""/>
                            <Name>Mr. James Connor</Name>
                            <Title>Consultant</Title>
                        </div>
                        <div className="gallery__team">
                            <img src ="/images/team/team2.jpg" alt =""/>
                            <Name>Sandra Jannikson</Name>
                            <Title>Sales Representative</Title>
                        </div>
                        <div className="gallery__team">
                            <img src ="/images/team/team3.jpg" alt =""/>
                            <Name>Benjamin Egabi</Name>
                            <Title>Sales Director</Title>
                        </div>
                        <div className="gallery__team">
                            <img src ="/images/team/team4.jpg" alt =""/>
                            <Name>Maureen Adekunle</Name>
                            <Title>Senior Advisor</Title>
                        </div>
                    </Gallery>
                    <TeamCaption>
                        <h1>We are here to help your business Call to discuss your Solution</h1>
                    <Call>
                        <span className="call-icon"><i class="fa fa-phone" aria-hidden="true"></i></span>
                        <span>+234(0) 80 9713 7563</span>
                    </Call>
                </TeamCaption>
                </Container> */}
            <Footer/>
        </>
    )
}


// const Container = styled.div`
//     padding: 50px 20px;

//     @media(min-width: 768px){
//         padding: 50px;
//     }
//     @media(min-width: 960px){
//         padding: 20px;
//     }
//     font-size: 15px;
// `

const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;

        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url("/images/team/team.jpg");
        background-size: cover;
        background-position-x: center;

        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;

    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        max-width: 80%;
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
    }
    
`


// const Gallery = styled.div`
// display: flex;
// flex-direction: column;

// @media(min-width: 500px){
//     flex-direction: row;
//     justify-content: space-between;
//     flex-wrap: wrap;
// }
// img{
//     width: 100%;
//     height: 300px;
//     object-fit: contain;

//     @media(min-width: 768px){
//         height: 400px;
//         object-fit: cover;
//         width: 100%;
//     }
// }

// div.gallery__team{
//     margin-bottom: 20px;

//     @media(max-width: 490px){
//         width: 100%;
//     }

//     @media(min-width: 490px){
//         width: 100%;
//     }

//     @media(min-width: 960px){
//         width: 24%;
//     }
// }

// `

// const Name = styled.div`
//     font-size: 20px;
//     font-weight: 500;
//     font-family: 'Rubik', sans-serif;
//     color: rgb(231, 60, 62);

//     @media( min-width: 492px){
//         text-align: center;
//     }
    
// `

// const Title = styled.div`
//     @media( min-width: 492px){
//         text-align: center;
//     }
// `

// const TeamCaption = styled.div`
//     height: 50vh;
//     background: rgb(231, 60, 62);
//     color: rgb(255, 255, 255);
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     text-align: center;
//     justify-content: space-between;
//     padding: 20px 20px 30px 20px;
//     border-radius: 5px;

//     @media(min-width: 768px){
//         flex-direction: row;
//         padding: 50px;
//         height: 40vh;
//         position: relative;
//         top: 50px;
//     }

//     @media(min-width: 490px){
//         display: none;
//     }

//     h1{
//         font-weight: 400;
//         line-height: 36px;
//         flex: 2;

//         @media(min-width: 768px){
//             font-size: 36px;
//             text-align: start;
//             line-height: 43.2px;
//         }
//     }
    
//     span.call-icon{
//         background: rgb(255, 255, 255);
//         width: 50px;
//         padding: 10px;
//         border-radius: 50%;
//         color: red;
//         margin-bottom: 5px;
//     }
    
// `
// const Call = styled.div`
//     font-weight: 400;
//     line-height: 36px;
//     font-size: 25px; 
//     cursor: pointer;
//     flex: 1;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     @media(min-width: 768px){
//         flex-direction: row;
//         justify-content: space-around;
//     }
// `
export default TeamComponent